export class RecallClaimModel {
  ARClaimID: string;
  RecallReason: string;
  PatientID: string;
}
